import { BaseValue } from "./base-value";

export type CalledTypeLiterals<L extends string, P, R = void> = {
  [key in L]: (param?: P) => R;
};

// read form-state.ts
export abstract class BaseState<T extends string> extends BaseValue<T> {
  match<R>(matcher: CalledTypeLiterals<T, void, R>): R {
    return matcher[this.getValue()]();
  }
}
